<template>
    <form class="quantity-select text-left" @submit.prevent="handleSubmitted">
        <template v-if="showLabel">
            <label class="small mb-0" :for="id" style="font-size: .75rem">quantité</label>
        </template>
        <div class="input-group">
            <slot name="prepend"/>
            <template v-if="isSelect">
                <select
                    :id="id"
                    name="quantity"
                    :value="count"
                    class="custom-select quantity-select__select"
                    :class="inputClasses"
                    :disabled="isPending"
                    @change="handleSelectChanged"
                    ref="input"
                >
                    <option v-for="i in max" :value="i">{{ optionContent(i) }}</option>
                </select>
            </template>
            <template v-else>
                <input
                    :id="id"
                    name="quantity"
                    :value="count"
                    class="form-control quantity-select__input"
                    :class="inputClasses"
                    maxlength="3"
                    :disabled="isPending"
                    @input="handleInputChanged"
                    @blur="handleInputBlur"
                    ref="input"
                />
            </template>
            <template v-if="!hideButton">
                <div class="input-group-append d-none d-sm-flex">
                    <button class="btn btn-light text-uppercase" type="submit" :disabled="isPending">ok</button>
                </div>
            </template>
        </div>
        <template v-if="error">
            <div class="invalid-feedback d-block">
                {{ error }}
            </div>
        </template>
    </form>
</template>

<script>
    import axios from 'axios';
    import debounce from 'lodash/debounce';

    export default {
        props: {
            value: [String, Number],
            max: Number,
            endpoint: String,
            name: String,
            hideButton: Boolean,
            showLabel: Boolean,
            size: String
        },
        data() {
            return {
                count: this.value,
                error: null,
                isPending: false,
                isCustom: this.value >= this.max,
            }
        },
        watch: {
            async isSelect(val) {
                if(!val) {
                    await this.$nextTick();
                    this.focus();
                }
            },
            value(val) {
                this.count = val;
            }
        },
        computed: {
            isSelect() {
                return !this.isCustom && this.count < this.max;
            },
            inputState() {
                return this.error && !this.error;
            },
            id() {
                return this.name;
            },
            inputClasses() {
                return {
                    'is-invalid': this.error,
                }
            },
        },
        methods: {
            optionContent(i) {
                return `${i}${i===this.max?'+':''}`;
            },
            apiPost: debounce(async function(endpoint) {
                if(this.isPending)
                    return;
                this.isPending = true;
                try {
                    let response = await axios.post(endpoint, {
                        [this.name]: this.count
                    });
                    this.$emit('update', response.data);
                }
                catch(error) {
                    console.log(error);
                    if(error.response.status === 422) {
                        this.error = error.response.data.errors[this.name][0];
                    }
                }
                finally {
                    this.isPending = false;
                }
            }, 200),
            post() {
                if(this.endpoint) {
                    this.apiPost(this.endpoint);
                } else {
                    this.$emit('change', this.count);
                }
            },
            focus() {
                const input = this.$refs.input;
                if(input) {
                    input.focus();
                    setTimeout(() => {
                        input.selectionStart = input.selectionEnd = input.value.length;
                    }, 0);
                }
            },
            handleInputChanged(e) {
                this.count = e.target.value;
                this.error = null;
            },
            handleSelectChanged(e) {
                this.count = Number(e.target.value);
                console.log(this.count);
                this.error = null;
                if(this.isSelect) {
                    this.post();
                } else {
                    this.isCustom = true;
                }
            },
            handleInputBlur() {
                this.post();
            },

            handleSubmitted() {
                this.$refs.input.blur();
                this.post();
            }
        },
    }
</script>